import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Upper Body / Core' second='Workout 02' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Chest / Shoulders',
							value: 'Push - ups',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: '(A) Chest / Shoulders',
							value: 'Lateral raises w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Side Plank (each side)',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec (each side)',
						},
					],
					[
						{
							header: '(A) Chest / Shoulders',
							value: 'Decline Push - UPs',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Chest / Shoulders',
							value: 'Shoulder Press w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Knee Tucks',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Chest / Shoulders',
							value: 'Burpees',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
